import { render, staticRenderFns } from "./Drinks.vue?vue&type=template&id=1c05f686&scoped=true&lang=pug"
import script from "./Drinks.vue?vue&type=script&lang=js"
export * from "./Drinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05f686",
  null
  
)

export default component.exports